import apiClient from "./apiClient";

export const getApprovalById = async (id) => {
  try {
    const response = await apiClient.get(
      `/admin/approval/get_approval_by_id/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approvalAccept = async (id) => {
  try {
    const response = await apiClient.put(
      `/admin/approval/accept/${id}`, {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approvalReject = async (id) => {
  try {
    const response = await apiClient.delete(
      `/admin/approval/reject/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
